import { Suspense } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { selectIsStoresListDrawerOpen } from '../../../../flux/selectors/ux'
import { selectLabel } from '../../../../flux/selectors/i18n'
import { uxEvent } from '../../../../flux/actions/ux'
import lazyfy from '../../../../helpers/lazyfy'

import BottomDrawer from '../../BottomDrawer'
import { BottomDrawerProvider } from '../../../ui/contexts/BottomDrawerContext'

const StoresInfo = lazyfy(() => import('../StoresInfo'))

const StoresListDrawer = () => {
  const dispatch = useDispatch()
  const storesDrawerTitle = useSelector(selectLabel('nearestStores'))
  const isStoresListOpen = useSelector(selectIsStoresListDrawerOpen)

  const onStoresListDrawerClose = () => {
    dispatch(uxEvent({
      name: 'toggle',
      target: 'StoreInfo/StoresList',
      params: { open: false },
    }))
  }

  return (
    <BottomDrawerProvider>
      <BottomDrawer
        onClose={onStoresListDrawerClose}
        open={isStoresListOpen}
        title={storesDrawerTitle}
        expanded
      >
        <Suspense>
          <StoresInfo />
        </Suspense>
      </BottomDrawer>
    </BottomDrawerProvider>
  )
}

export default StoresListDrawer
